import { useMemo } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import getCookies from 'hb-react/shared/apps/CookieBanner/utils/getCookies';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import { generateCookieParams } from '../utils/generateCookieParams';

export const useCookieList = (env) => {
  const { currentNetwork } = useDefaultAppContexts();
  const {
    flagActivateFrontMonitoringDatadog,
    flagAxpPlanhatIntegration,
    flagTtPoRemoveUserSessionCookie,
    flagUeNewOutdatedBrowserDetection,
  } = useFeatureFlag();

  return useMemo(() => {
    const cookieParams = generateCookieParams(env, currentNetwork);

    const cookieLists = getCookies({
      ...cookieParams,
      flagActivateFrontMonitoringDatadog,
      flagAxpPlanhatIntegration,
      flagTtPoRemoveUserSessionCookie,
      flagUeNewOutdatedBrowserDetection,
    });

    return { cookieLists, cookieParams };
  }, [
    currentNetwork,
    env,
    flagActivateFrontMonitoringDatadog,
    flagAxpPlanhatIntegration,
    flagTtPoRemoveUserSessionCookie,
    flagUeNewOutdatedBrowserDetection,
  ]);
};
